<template>
  <RequestWizardStep name="Request Type"
    :complete="requestType !== null"
  >
    <ContentCard
      title="OK! Now please tell us a little more about the records request you are making."
    >
      <ReflectAttrs
        v-bind="{ requestTypeLabel: 'I am making a' }"
        v-slot="{ requestTypeLabel }"
      >
        <div>
          <p class="lead">{{ requestTypeLabel }}:</p>

          <StepSelection>
            <RadioButtons
              :aria-label="requestTypeLabel"
              :options="[
                {
                  value: 'general',
                  label: 'General records request (ex. Correspondence, Emails, Calendars,'
                    + ' Presentation Materials, Reports)'
                },
                {
                  value: 'firstParty',
                  label: 'Personal records request (ex. Your personnel file or records about you)'
                },
                {
                  value: 'thirdParty',
                  label: 'Records on another\'s behalf (ex. You represent someone or have'
                    + ' authorization to act on another\'s behalf and you seek the individual\'s'
                    + ' personnel file or records about them)'
                }
              ]"
              v-model="requestType"
            />
          </StepSelection>
        </div>
      </ReflectAttrs>
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import subComponent from '@ssi/vue-common/src/mixins/subComponent';
import RadioButtons from '@/components/formFields/RadioButtons';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';
import StepSelection from '@/components/requestWizard/StepSelection';

export default {
  mixins: [subComponent],

  components: {
    RadioButtons, RequestWizardStep, StepSelection
  }
};
</script>
